export const POSTURE_THEME = {
  colors: {
    good: { bg: 'bg-cyan-500/20', border: 'border-cyan-500', text: 'text-cyan-400', hex: '#22d3ee' },
    warning: { bg: 'bg-amber-500/20', border: 'border-amber-500', text: 'text-amber-400', hex: '#f59e0b' },
    critical: { bg: 'bg-rose-500/20', border: 'border-rose-500', text: 'text-rose-400', hex: '#ef4444' },
    neutral: { bg: 'bg-slate-700/50', border: 'border-slate-600', text: 'text-slate-300', hex: '#cbd5e1' }
  },
  glass: 'bg-slate-800/70 backdrop-blur-sm border border-slate-700/50',
  skeleton: {
    good: '#22d3ee',
    moderate: '#f59e0b', 
    severe: '#ef4444'
  },
  layout: {
    maxContentWidth: 'max-w-7xl',
    panelGap: 'gap-6'
  }
};

